// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"book-unknown"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M2 3H9C10.6569 3 12 4.34315 12 6V21H11C11 21 8 20 2 20V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M22 3H15C13.3431 3 12 4.34315 12 6V21H13C13 21 16 20 22 20V3Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 21V6M12 21H11C11 21 8 20 2 20V3H9C10.6569 3 12 4.34315 12 6M12 21H13C13 21 16 20 22 20V3H15C13.3431 3 12 4.34315 12 6","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M15 10.5C15 9.39543 15.8954 8.5 17 8.5C18.1046 8.5 19 9.39543 19 10.5C19 12.5 17.0034 12.5278 17.0034 12.75M17 15.5H17.0039V15.5039H17V15.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-book-unknown')
export default class BookUnknownIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'book-unknown',
    }
  }
}
